// extracted by mini-css-extract-plugin
export default {"root":"jhf2w__root","rootStopped":"Tavs3__rootStopped","image":"m875F__image"};